var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"flashcard-view-container",staticClass:"grouping-show-view-component"},[(_vm.loading)?_c('loading'):_vm._e(),_vm._v(" "),(_vm.quizGrouping)?[_c('groupings-quiz-view',{attrs:{"asset-association":_vm.assetAssociation,"breadcrumbs":_vm.breadcrumbs,"category":_vm.category,"grouping":_vm.grouping}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }